import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { Response } from 'src/app/interfaces/interface-bakend/response';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class SignoPadronesService {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthService
    ) {}

    async processSpecialistPdf(file: File, localidadId: string, gerenciadoraId: string, zonaId: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);

            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/processSpecialistPdf?signoLocalidadId=${localidadId}&signoGerenciadoraId=${gerenciadoraId}&signoZonaId=${zonaId}`;

            this.httpClient.post(url, formData, { headers }).subscribe(
                (resp) => resolve(resp),
                (error) => reject(error)
            );
        });
    }

    async getUnmatchedSpecialties(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.get<Response>(`${URL_BACKEND}/signo-padrones/unmatched-specialties`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getUnmatchedAddresses(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.get<Response>(`${URL_BACKEND}/signo-padrones/unmatched-addresses`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getSummary(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.get<Response>(`${URL_BACKEND}/signo-padrones/get-summary`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getAllRecords(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.get<Response>(`${URL_BACKEND}/signo-padrones/all-records`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async geolocateAll(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.post<Response>(`${URL_BACKEND}/signo-padrones/geolocate-all`, {}, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async geolocateOneAddress(domicilio: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/geolocate-one-address?domicilio=${encodeURIComponent(domicilio)}`;
            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async updateSpecialtyMapping(especialidad: string, especialidadId: string, rubroId: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/update-specialty-mapping?especialidad=${encodeURIComponent(especialidad)}&especialidadId=${especialidadId}&rubroId=${rubroId}`;
            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async createAndMapSpecialty(especialidad: string, parentId: string, rubroId: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/create-and-map-specialty?especialidad=${encodeURIComponent(especialidad)}&parentId=${parentId}&rubroId=${rubroId}`;
            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async updateAddressMapping(oldAddress: string, newStreet: string, newNumber: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/update-address-mapping?oldAddress=${encodeURIComponent(oldAddress)}&newStreet=${encodeURIComponent(newStreet)}&newNumber=${encodeURIComponent(newNumber)}`;
            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async saveImportHistory(data: any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.post<Response>(`${URL_BACKEND}/signo-padrones/import-history`, data, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getImportHistory(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.get<Response>(`${URL_BACKEND}/signo-padrones/import-history`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async clearImportHistory(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient.delete<Response>(`${URL_BACKEND}/signo-padrones/import-history`, { headers }).subscribe(
                (resp: Response) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }
}
